import DgIframe from './src/main.vue'
// 为组件提供 install 安装方法，供按需引入
DgIframe.install = function (Vue) {
  Vue.component(DgIframe.name, DgIframe)
}
export default DgIframe

export { DgIframe }